import { apiClient, type PageEntity, type TruckClassEntity } from '@/libs/api'

export type TruckClassesRequestQuery = {
  name?: string
  enable?: boolean
  page?: number
  take?: number
}

export type FetchTruckClassesQuery = {
  tenantKey: string
  query?: TruckClassesRequestQuery
}

export type FetchTruckClassesResponse = {
  data: TruckClassEntity[]
  pagination: PageEntity | null
}

// 車格一覧(車格マスタ一覧ページ用)を取得
export const fetchTruckClassesList = async (
  { tenantKey, query }: FetchTruckClassesQuery,
  signal?: AbortSignal
): Promise<FetchTruckClassesResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .truck_classes.list.$get({
      query,
      config: { signal }
    })

  return { data, pagination }
}
